import {Injectable, Input} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {filter, tap} from 'rxjs/operators';
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
    @Input() subMenu: any = [];
    constructor(private router: Router, protected toastr: ToastrService, private location: Location) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
          tap({
            next: (event) => {
              if (event instanceof HttpResponse) {
                if(event.status === 401 || event.status === 403) {
                  this.router.navigate(['/dashboard'])
                      .then(() => {
                          window.location.reload();
                      });
                }
              }
            },
            error: (error) => {
              if(error.status === 401 || error.status === 403) {
                this.router.navigate(['/dashboard'])
                    .then(() => {
                        window.location.reload();
                    });
                }
            }
          }));
      }

      toasterClickedHandler() {
        alert('Toastr clicked');
      }
}
